import { HTMLProps, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type FormBlockProps = HTMLProps<HTMLDivElement>;

export const FormBlock = memo<FormBlockProps>(({ className, children, ...props }) => {
  return (
    <div className={classNames(className, styles.root)} {...props}>
      {children}
    </div>
  );
});